export const FORM_NAME = 'CashDepositAdd'

export const CHECK_DEBIT_ACCOUNT_FETCHER_NAME = 'CashDeposit/CHECK_DEBIT_ACCOUNT'
export const GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME = 'CashDeposit/GET_DEBIT_ACCOUNT_VIEW'

export const CHECK_CREDIT_ACCOUNT_FETCHER_NAME = 'CashDeposit/CHECK_CREDIT_ACCOUNT'
export const GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME = 'CashDeposit/GET_CREDIT_ACCOUNT_VIEW'

export const ORDER_CASH_OUT_ADD_IN_NAVIGATION = 'OrderCashOutAddInNavigation'
export const ORDER_CASH_IN_ADD_IN_NAVIGATION = 'OrderCashInAddInNavigation'

export const ORDER_CASH_OUT_COPY = 'OrderCashOutCopy'
export const ORDER_CASH_IN_COPY = 'OrderCashInCopy'
